import * as React from 'react';
import clsx from 'clsx';

type CheckboxAttributes = React.InputHTMLAttributes<HTMLInputElement>;

type Props = {
  label: string;
  id: CheckboxAttributes['id'];
  disabled?: CheckboxAttributes['disabled'];
  checked?: CheckboxAttributes['checked'];
  onChange?: CheckboxAttributes['onChange'];
  large?: boolean;
  stripped?: boolean;
  round?: boolean;
};

const Checkbox = ({
  label,
  id,
  disabled = false,
  checked = false,
  onChange,
  large = false,
  stripped = false,
  round = false,
}: Props) => {
  return (
    <div
      className={`flex items-center gap-8${disabled ? ' cursor-not-allowed' : ' cursor-pointer'}${
        stripped ? '' : ' px-8 md:px-16'
      }`}
    >
      <div className="relative flex h-16 w-16 items-center justify-center">
        <input
          id={id}
          checked={checked}
          disabled={disabled}
          type="checkbox"
          className={`
            peer absolute h-full w-full cursor-pointer appearance-none border-1 border-black-25
            bg-[#E1E1E2] transition-all
            ${round ? 'rounded-full' : 'rounded-4'}
            checked:border-red-100 checked:bg-white-15
            disabled:cursor-not-allowed disabled:border-black-25 disabled:bg-black-25
            hover:[&:not(:disabled)]:border-black-100
          `}
          onChange={onChange}
        />
        <div
          className={`pointer-events-none h-8 w-8 bg-red-100 transition-all ${
            round ? 'rounded-full' : 'rounded-2'
          } scale-0 peer-checked:scale-100`}
        />
      </div>
      {label && (
        <label
          htmlFor={id}
          className={clsx(disabled ? 'cursor-not-allowed text-black-25' : 'text-black-10 cursor-pointer', {
            'label-lg': large,
            'label-md': !large,
          })}
        >
          {label}
        </label>
      )}
    </div>
  );
};
export default Checkbox;
